import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IElearningTopicTranslationVm } from '../elearning-topic-translation-vm.model';
import { IOperatorElearningTopicTranslationIm } from '../operator-elearning-topic-translation-im.model';
import { IOperatorElearningTopicTranslationUm } from '../operator-elearning-topic-translation-um.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicTranslationService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopicTranslation`;
  }
  post(translationIm: IOperatorElearningTopicTranslationIm): Observable<IElearningTopicTranslationVm> {
    const headers = this.createHeaders();
    return this.http.post<IElearningTopicTranslationVm>(this.baseUrl, translationIm, { headers });
  }
  put(translationUm: IOperatorElearningTopicTranslationUm): Observable<IElearningTopicTranslationVm> {
    const headers = this.createHeaders();
    return this.http.put<IElearningTopicTranslationVm>(this.baseUrl, translationUm, { headers });
  }
  delete(id: number): Observable<any> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.delete<any>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
